<template>
<div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.list.user.label.title')}}</h4>

                            </div>
                        </div>
                    </div>
                    <!-- Form row -->
                    <div class="row" v-if="data._id">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.list.user.label.decription')}}
                                </p>
                                <form>

                                    <div v-if="data._id" class="form-row">
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code> {{$t('string.msg.product.brand.label.id')}}
                                            </label>
                                            <input type="text" readonly v-model="data._id" class="form-control">
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.list.user.label.name')}}
                                            </label>
                                            <input type="text" v-model="data.firstName" class="form-control">
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.list.user.label.lastname')}}
                                            </label>
                                            <input type="text" v-model="data.lastName" class="form-control">
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6" v-if="data.type == 'USER-COMPANY'">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.list.user.label.email')}}
                                            </label>
                                            <input type="text" v-model="data.email" class="form-control" readonly>
                                        </div>
                                        <div class="form-group col-md-6" v-else-if="data.type == 'USER-CUSTOMER'">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.trucker.label.phone')}}
                                            </label>
                                            <input type="text" v-model="data.primaryPhone" class="form-control" readonly>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.list.user.label.type')}}
                                            </label>
                                            <input v-if="data.type == 'USER-COMPANY'" :placeholder="toUpperCase($t('string.msg.user.type.company'))"  type="text" class="form-control" readonly>
                                            <input v-else-if="data.type == 'USER-CUSTOMER'"  :placeholder="toUpperCase($t('string.msg.user.type.customer'))" type="text" class="form-control" readonly>
                                        </div>
                                    </div>
                                    <div class="form-row" v-if="data.companyUser">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.list.user.label.company')}}
                                            </label>
                                            <input type="text" v-model="data.companyUser.company.fantasyName" class="form-control" readonly>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.list.user.label.primaryPhone')}}
                                            </label>
                                            <input type="text" v-model="data.companyUser.company.primaryPhone" class="form-control">
                                        </div>
                                    </div>

                                     <div class="form-row" v-if="data">
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.list.user.label.new.password')}}
                                            </label>
                                            <input type="text" v-model="newPassword" class="form-control" :placeholder="toUpperCase($t('string.msg.user.type.new.password.placeholder'))" >
                                        </div>
                                        <div class="form-group col-md-2">
                                            <br>
                                            <br>
                                            <button v-on:click="checkForm" class="text-dark-gray btn btn-warning w-100">{{$t('string.msg.status.change')}}</button>
                                        </div>
                                    </div>
                                    <div class="form-row" v-if="data && data.type == 'USER-COMPANY'">
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.list.user.label.new.email')}}
                                            </label>
                                            <input type="text" v-model="newEmail" class="form-control" :placeholder="toUpperCase($t('string.msg.user.type.new.email.placeholder'))" >
                                        </div>
                                        <div class="form-group col-md-2">
                                            <br>
                                            <br>
                                            <button v-on:click="checkFormEmail" class="text-dark-gray btn btn-warning w-100">{{$t('string.msg.status.change')}}</button>
                                        </div>
                                    </div>

                                    <div class="form-row" v-else-if="data && data.type == 'USER-CUSTOMER'">
                                        <div class="form-group col-md-3">
                                            <label for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.trucker.label.phone')}}
                                            </label>
                                            <input type="text" v-model="newPhone" class="form-control" :placeholder="toUpperCase($t('string.msg.user.type.new.phone.placeholder'))" >
                                        </div>
                                        <div class="form-group col-md-2">
                                            <br>
                                            <br>
                                            <button v-on:click="checkFormPhone" class="text-dark-gray btn btn-warning w-100">{{$t('string.msg.status.change')}}</button>
                                        </div>
                                    </div>

                    
                                    <div class="form-row">
                                        <div class="form-group col-md-6 text-center">
                                            <button @click="clearForm" class="btn btn-secondary w-50 mt-4">{{$t('string.msg.form.btn.clear')}}</button>
                                        </div>
                                         <div class="form-group col-md-6 text-center">
                                            <button @click="changePassword" class="btn btn-danger w-50 mt-4">{{$t('string.msg.form.btn.update')}}</button>
                                        </div>
                                    </div>
                                    <br><br>
                                    <div v-if="errors.length" class="alert alert-danger">
                                        <p class="lead">{{$t('response.msg.alert')}}</p>
                                        <ul>
                                            <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                                        </ul>
                                    </div>

                                </form>

                                </div>
                        </div>
                    </div>
                    <List v-on:load-item="selectItem"/>
                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" v-on:confirmation-return="archive"/>
        <FlashMessage/>
    </div>
</template>

<script>
import Controller from './CrtUser';

import List from './ListUser';

import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Confirmation from '../../../components/layout/Confirmation';

export default {
  name: 'User',
  components: {
    Spinner,
    Toast,
    List,
    Confirmation
  },
  data() {
      return {
        errors: [],
        addresses: [],
        valuekey: 0,
        trucks: null,
        newEmail: null,
        newPassword: null,
        newPhone: null,
        types: [
            {_id:"PART_SUPPLIER", name:this.$t('string.msg.company.label.type.autoparts')},
            {_id:"CERTIFIER", name:this.$t('string.msg.company.label.type.certifier')},
            {_id:"SERVICE_PROVIDER", name:this.$t('string.msg.company.label.type.serviceprovider')}
        ],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        company:null,
        searchBy: null,

        data: {
            firstName: null,
            lastName: null,
            email: null,
            password: null,
            primaryPhone: null,
            type: "USER-CUSTOMER",
                customerUser: {
                subtype: "TRUCK_DRIVER",
                dateBirth: null,
                document: null,
                cnh: null,
                rg: null,
                selfiePhotoURL: 'xxxxx',
                obsCNH: null,
                gender: null,
                company: null,
            }
        },
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
  },
  mounted(){
  }
}
</script>

<style>
</style>
